function notReferredToOrByGroup(groupId, referredToId, referredById) {
  return groupId !== referredToId && groupId !== referredById;
}

export default notReferredToOrByGroup;
